interface CheckCircleProps {
  className?: string;
}

const CheckCircle = ({ className }: CheckCircleProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5293_9048)">
      <path
        d="M19.1663 10C19.1663 15.0625 15.0622 19.1667 9.99967 19.1667C4.93717 19.1667 0.833008 15.0625 0.833008 10C0.833008 4.93754 4.93717 0.833374 9.99967 0.833374C15.0622 0.833374 19.1663 4.93754 19.1663 10ZM7.75384 15.0917L15.5888 7.25587L14.4105 6.07754L7.84134 12.6467L5.77801 10.1384L4.51884 11.23L7.75384 15.0909V15.0917Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5293_9048">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CheckCircle;
